module.exports = __webpack_public_path__ + "static/media/14.77f78719.png";